import { colorPalette } from "../../colorPalette";
export const table = {
    border: `1px solid ${colorPalette.gray200}`,
    borderRadius: '4px',
    overflow: 'hidden',
};
export const tableHeadCell = (isNotLast, selected) => {
    const style = {
        backgroundColor: selected ? colorPalette.gray200 : colorPalette.gray100,
        fontWeight: 400,
        padding: '8px 12px'
    };
    let returnedStyle = Object.assign({}, style);
    if (isNotLast) {
        returnedStyle = Object.assign(Object.assign({}, returnedStyle), { borderRight: `1px solid ${colorPalette.gray200}` });
    }
    return returnedStyle;
};
export const tableName = {
    color: colorPalette.gray900,
    padding: '8px 12px',
    textAlign: 'center',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    background: colorPalette.gray200,
    lineHeight: 'normal'
};
export const tableRow = (rowBorderBottom) => {
    let returnedStyle = {};
    if (rowBorderBottom) {
        returnedStyle = {
            borderBottom: `1px solid ${colorPalette.gray200}`,
            '&:last-child': {
                borderBottom: 'none'
            }
        };
    }
    return returnedStyle;
};
export const verticalTableBodyCell = (isNotLast, selected) => {
    const style = {
        borderBottom: 'none',
        padding: '8px 12px'
    };
    let returnedStyle = Object.assign({}, style);
    if (isNotLast) {
        returnedStyle = Object.assign(Object.assign({}, returnedStyle), { borderRight: `1px solid ${colorPalette.gray200}` });
    }
    if (selected) {
        returnedStyle = Object.assign(Object.assign({}, returnedStyle), { backgroundColor: colorPalette.gray100 });
    }
    return returnedStyle;
};
export const horizontalTableBodyHeadCell = (isNotLast, selected) => {
    const style = {
        backgroundColor: colorPalette.gray100,
        borderBottom: 'none',
        fontWeight: 400,
        color: colorPalette.gray900,
        padding: '8px 12px'
    };
    let returnedStyle = Object.assign({}, style);
    if (isNotLast) {
        returnedStyle = Object.assign(Object.assign({}, returnedStyle), { borderBottom: `1px solid ${colorPalette.gray200}` });
    }
    if (selected) {
        returnedStyle = Object.assign(Object.assign({}, returnedStyle), { backgroundColor: colorPalette.gray200 });
    }
    return returnedStyle;
};
export const horizontalTableBodyCell = (isNotLast, selected) => {
    const style = {
        borderBottom: 'none',
        color: colorPalette.gray800,
        padding: '8px 12px'
    };
    let returnedStyle = Object.assign({}, style);
    if (isNotLast) {
        returnedStyle = Object.assign(Object.assign({}, returnedStyle), { borderBottom: `1px solid ${colorPalette.gray200}` });
    }
    if (selected) {
        returnedStyle = Object.assign(Object.assign({}, returnedStyle), { backgroundColor: colorPalette.gray100 });
    }
    return returnedStyle;
};
